import React from "react";
import { BiTransfer } from "react-icons/bi";
import { LiaStarSolid } from "react-icons/lia";
import { MdAccountCircle } from "react-icons/md";
import {
  formatAmount,
  formatDateStrToDate,
  formatRating,
  formatTimeStampToDate,
} from "../utils";

function TransactionDetails({ content }) {
  const { getDataById } = content;

  return (
    <div className=" flex flex-col justify-between w-full gap-2.5">
      <div className=" flex flex-col gap-6 w-full flex-wrap">
        <div className="flex flex-col gap-6">
          <div className="flex flex-row gap-2">
            <span className="text-4xl text-b-mc/70 ">
              <MdAccountCircle />
            </span>
            <div className="flex flex-col ">
              <span>{getDataById?.unique_code}</span>
              <div className="flex flex-row gap-4 items-center">
                <p className="flex flex-row gap-2 items-center text-xs text-s-bk">
                  Rating {formatRating(getDataById?.user?.rating)}
                  <span className="text-green-500">
                    <LiaStarSolid />
                  </span>
                </p>
                <p className="flex flex-row gap-2 items-center text-xs text-s-bk">
                  Order Completed {getDataById?.user?.trx_stats?.completed}
                  <span className="text-green-500">{<BiTransfer />}</span>
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-between">
            {" "}
            <div className="flex flex-row gap-2">
              {/* <span className="pt-[2px] text-sm text-s-bk">
                    <FaCalendarAlt />
                  </span> */}
              <p className="flex flex-col gap-1">
                {formatTimeStampToDate(getDataById?.deadline)}
                <span className="text-xs text-s-bk">Transaction deadline</span>
              </p>
            </div>
            <div className="flex flex-row gap-2">
              {/* <span className="pt-[2px] text-xl text-b-mc">
                    <BiTransfer />
                  </span> */}
              <p className="flex flex-col gap-1">
                {getDataById?.transaction_method?.name}

                <span className="text-xs text-s-bk">Payment Method</span>
              </p>
            </div>
            <div className="flex flex-row gap-2">
              {/* <span className="pt-[2px] text-sm text-b-mc">
                    <FaCalendarAlt />
                  </span> */}
              <div className="flex flex-col gap-1">
                <div className="flex flex-row gap-1 md:gap-2 items-center">
                  <p>
                    {formatAmount(getDataById?.amount)}{" "}
                    {getDataById?.quote_currency?.symbol}{" "}
                  </p>
                  <img
                    src={getDataById?.quote_currency?.country?.flag}
                    alt="currency flag"
                    className="block w-5 h-[13px]"
                  />{" "}
                </div>
                <span className="text-xs text-s-bk">Available amount</span>
              </div>
            </div>
          </div>
          <div className="flex flex-col">
            <small className="border-x-[2px] text-[10px] mr-2 border-b-mc rounded text-p-bk/0" />
            <p className="flex flex-row items-baseline gap-2 text-orange-500">
              {/* <span className="text-xs text-s-bk">Status</span> */}
              Transaction {getDataById?.transaction_status?.name}
            </p>
          </div>
        </div>
      </div>
      <div className=" border-dashed border-y-hf border-t-bk bg-b-mct py-2 px-11 flex flex-col gap-2">
        <p className="flex flex-row justify-between text-sm text-s-bk">
          Rate{" "}
          <span className="text-p-bk">
            1 {getDataById?.quote_currency?.symbol} ~{" "}
            {formatRating(getDataById?.rate)}{" "}
            {getDataById?.base_currency?.symbol}
          </span>
        </p>
        <p className="flex flex-row justify-between text-sm text-s-bk">
          Transaction fee ({Number(getDataById?.auth_user_commission / (getDataById?.amount * getDataById?.rate) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%)<span className="text-p-bk">{(getDataById?.auth_user_commission)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{" "}
            {getDataById?.base_currency?.symbol}</span>
        </p>
        <p className="flex flex-row justify-between text-sm text-s-bk">
          Discount <span className="text-p-bk">
          {getDataById?.discount ? (getDataById?.discount)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00' }{" "}
          {getDataById?.base_currency?.symbol}
          </span>
        </p>
        <p className="flex flex-row justify-between text-sm text-s-bk">
          Total Amount{" "}
          <span className="text-p-bk">
            {(getDataById?.amount * getDataById?.rate)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{" "}
            {getDataById?.base_currency?.symbol}
          </span>
        </p>
        <p className="flex flex-row justify-between text-sm text-s-bk">
          Grand Total Amount{" "}
          <span className="text-p-bk">
            {((getDataById?.amount * getDataById?.rate) + getDataById?.auth_user_commission)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{" "}
            {getDataById?.base_currency?.symbol}
          </span>
        </p>

      </div>
    </div>
  );
}

export default TransactionDetails;
